import { render, staticRenderFns } from "./PaginacaoTabela.vue?vue&type=template&id=f80840cc&scoped=true"
import script from "./PaginacaoTabela.vue?vue&type=script&lang=js"
export * from "./PaginacaoTabela.vue?vue&type=script&lang=js"
import style0 from "./PaginacaoTabela.vue?vue&type=style&index=0&id=f80840cc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80840cc",
  null
  
)

export default component.exports